/**
 * Tags Container Component
 * Container for game badges (jackpot badges, etc.)
 */

import React from 'react';
import styles from './GameComponents.module.css';
import { useAppStore } from '../../../../../../store/app/appStore';
import { useSeasonalBranding } from '../../../../../../store/featureFlags/featureFlagsStore';

interface TagsContainerProps {
  children: React.ReactNode;
  isSPJjackpot?: boolean;
  shouldUseBrandingForBadges?: boolean;
}

const TagsContainer: React.FC<TagsContainerProps> = ({ children, isSPJjackpot = false, shouldUseBrandingForBadges }) => {
  const { viewMode } = useAppStore.getState();
  const seasonalBranding = useSeasonalBranding();
  
  // Only set data-branding if this specific jackpot should use branding
  const brandingAttribute = shouldUseBrandingForBadges && seasonalBranding ? seasonalBranding : undefined;
  
  return (
    <div data-view={viewMode} data-branding={brandingAttribute} className={`${styles.tagsContainer} ${isSPJjackpot ? styles.spjJackpot : styles.normalJackpot} egt_tags_container`}>
      {children}
    </div>
  );
};

export default TagsContainer;